import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading-text">
      <h1>Loading...</h1>
    </div>
  );
};

export default Loading;
